import { BILL_CREDIT_NOTICE, renderCostBasis } from "@/lib/disclosureTexts";

/**
 * The cost-basis sentence that sits with every estimated monthly cost. The words are CLO's, versioned in
 * lib/disclosureTexts.js (DRAFT); this component only renders them. `variant` "primary" is the detail page,
 * "short" is the plan card. The link is the plan's own Electricity Facts Label. A plan with bill credits or
 * usage-conditional pricing also gets the bill-credit notice directly beneath.
 */
export default function CostBasisLine({ plan, variant = "primary", className = "", testId }) {
  const line = renderCostBasis(variant, { eflUrl: plan && plan.efl_document_url });
  const hasBillCredit = !!(plan && typeof plan.bill_credit_conditions === "string" && plan.bill_credit_conditions.trim());
  return (
    <div className={className}>
      <p data-testid={testId} data-text-version={line.versionId} data-text-status={line.status}>
        {line.parts.map((p, i) =>
          p.href ? (
            <a key={i} href={p.href} target="_blank" rel="noopener noreferrer" className="underline font-semibold">{p.text}</a>
          ) : (
            <span key={i}>{p.text}</span>
          )
        )}
      </p>
      {hasBillCredit && (
        <p className="mt-2" data-testid={testId ? `${testId}-bill-credit` : undefined} data-text-version={BILL_CREDIT_NOTICE.id} data-text-status={BILL_CREDIT_NOTICE.status}>
          <strong>{BILL_CREDIT_NOTICE.lead}</strong> {BILL_CREDIT_NOTICE.text}
        </p>
      )}
    </div>
  );
}
